import * as types from '../../actions/actionTypes';
const initialState = {
  applicationInfo: [],
};

export default function reducer(state = initialState, action = '') {
  switch (action.type) {
    case types.SET_AGENT_INFO_PENDING: {
      return {
        ...state,
        isLoading: action.isLoading,
      };
    }
    case types.SET_AGENT_INFO_SUCCESS: {
      return {
        ...state,
        isLoading: action.isLoading,
        applicationInfo: action.data,
      };
    }
    case types.SET_AGENT_INFO_UPDATE: {
      console.log('Update Action', action);
      return Object.assign({}, state, {
        applicationInfo: state.applicationInfo.map(e => {
          if (e.id === action.data.id) {
            return action.data;
          }

          return e;
        }),
        isLoading: action.isLoading,
        message: 'The contract was successfully updated.',
      });
    }
    case types.SET_AGENT_INFO_DELETE: {
      return Object.assign({}, state, {
        applicationInfo: state.applicationInfo.filter(
          e => e.id !== action.data.id,
        ),
        isLoading: action.isLoading,
        message: action.msg,
      });
    }
    case types.SET_AGENT_INFO_ERROR: {
      return {
        ...state,
        isLoading: action.isLoading,
        error: action.error,
        hasError: true,
      };
    }
    case types.SET_REMOVE_INFO_ERROR: {
      return {
        ...state,
        hasError: false,
        error: undefined,
      };
    }
    // case types.SET_SEND_EMAIL_SUCCESS:
    //   return {
    //     ...state,
    //     isLoading: action.isLoading,
    //     emailSent: action.data,
    //   };
    case types.REDIRECT:
      return { ...state, redirectTo: null };
    case types.SET_AGENT_INFO_UPLOAD_PENDING: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case types.SET_AGENT_INFO_UPLOAD_SUCCESS: {
      return Object.assign({}, state, {
        applicationInfo: state.applicationInfo.map(ev => {
          if (ev.id === action.data.id) {
            return action.data;
          }

          return ev;
        }),
        isLoading: action.isLoading,
        message: 'The contract was successfully uploaded.',
      });
    }

    case types.SET_AGENT_INFO_DELETE_SUCCESS: {
      return Object.assign({}, state, {
        applicationInfo: state.applicationInfo.map(evn => {
          if (evn.id === action.data.id) {
            return action.data;
          }

          return evn;
        }),
        isLoading: action.isLoading,
        message: 'The contract was successfully deleted.',
      });
    }
    case types.SET_AGENT_INFO_UPLOAD_ERROR: {
      return {
        ...state,
        isLoading: false,
        error: action.error,
      };
    }

    case types.SET_REMOVE_ERROR: {
      return {
        ...state,
        isLoading: false,
        error: undefined,
        message: undefined,
      };
    }
    default:
      return state;
  }
}
